<template>
  <div id="app">
    <b-card>
      <b-card-header>
        <b-card-title>Staff Complaint Handling Performance</b-card-title>
      </b-card-header>
      <apexchart
        type="bar"
        :height="chartOptions.chart.height"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "StaffPerformance",
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    series() {
      return [
        {
          name: "Complaints Handled",
          type: 'column',
          data: this.data.map(staff => staff.complaintsHandled)
        },
        {
          name: "Average Rating",
          type: 'line',
          data: this.data.map(staff => (staff.averageRating * 100).toFixed(1))
        }
      ];
    },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: 'line',
          stacked: false,
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
            borderRadius: 4
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opt) {
            if (opt.seriesIndex === 1) {
              return val + "%";
            }
            return val;
          }
        },
        stroke: {
          width: [0, 4]
        },
        xaxis: {
          categories: this.data.map(staff => staff.staffName),
          title: {
            text: "Staff Members"
          },
          labels: {
            rotate: -45,
            rotateAlways: false,
            trim: true,
            maxHeight: 120
          }
        },
        yaxis: [
          {
            title: {
              text: "Complaints Handled"
            },
            min: 0
          },
          {
            opposite: true,
            title: {
              text: "Average Rating (%)"
            },
            min: 0,
            max: 100
          }
        ],
        colors: ["#2E93fA", "#66DA26"],
        tooltip: {
          shared: true,
          intersect: false,
          y: [{
            formatter: function(val) {
              return val + " complaints";
            }
          }, {
            formatter: function(val) {
              return val + "% rating";
            }
          }]
        },
        legend: {
          position: "top",
          horizontalAlign: "left"
        }
      };
    }
  }
};
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
  margin: 20px;
}
</style>